
<div class="father">
    <img src="assets/img/fondoFrase.png" class="bg">

    <h2>
        La vida nos encuentra
        en un momento único,
        y queremos que
        seas parte de él...
    </h2>
</div>